module.exports = __webpack_public_path__ + "img/portrait-icon.8a6cda03.jpg";